<template>
  <div class="input-wrapper">
    <label>{{label}}</label>
    <input class="input" ref="input" :value="value" v-bind="$attrs" @input="updateValue" :id="`test-input-${label.toLowerCase().replace(' ', '-')}`" />
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: '',
    },
    value: [String, Number],
  },
  methods: {
    updateValue(event) {
      this.$emit('input', event.target.value.trim());
    },
  },
};
</script>
